export default __webpack_public_path__ + "static/media/GothamSSm-Book.c833e23c.ttf";